import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from, map, Observable, throwError } from 'rxjs';
import { CommonService } from 'src/app/common.service';
import { MobileService } from 'src/app/mobile.services';
import { environment } from '../../../../environments/environment';
import { HttpRequestPayload } from '../../models/http.model';
import { HTTP } from "@ionic-native/http/ngx";

declare let cordova:any;

@Injectable({
  providedIn: 'root',
})
export class HttpProviderService {
  defaultContext:string = environment.defaultPublisher;
  fileUploadURL: string = '';
  keycloakURL: string = '';
  realm: string = '';
  client: string = '';
  restURL: string = '';
  idleTimeout: number;
  idleTimer: any;
  idleTimeCount: number = 0;
  promptIdleTimeoutB4: number = 30; //in second
  isPromptTimerAlert: boolean = false;
  defaultIdleTimeout: number = 5;

  constructor(
    private httpClient: HttpClient,
    private _commonService: CommonService,
    private _secureHttp: HTTP,
    private _mobileService:MobileService
  ) {}

  invokeApi(request: HttpRequestPayload, showSpinner = true): Observable<any> {
    if(showSpinner && request.method != 'GET') this._commonService.showSpinner();
    // else this._commonService.hideSpinner();
    let requestURL = environment.baseURL;
    requestURL += request.serverContext
      ? request.serverContext
      : this.getDefaultContext();

    requestURL += request.resource;

    /** append the query params */
    if (request.queryParams && request.queryParams.length > 0) {
      requestURL += '?';
      for (let key in request.queryParams) {
        let item = request.queryParams[key];
        if (item.value) {
          requestURL += `${item.key}=${item.value}&`;
        }
      }
      requestURL = requestURL.substring(0, requestURL.length - 1);
    }

    let headers: any = {
      'Content-Type': 'application/json',
      'authorization': this.authToken,
      'deviceInfo': this._commonService.encodedDeviceDetails,
      'languageId': environment.languageId
    };

    /** append the header params  */
    if (request.headerParams && request.headerParams.length > 0) {
      request.headerParams.map((param: any) => {
        if (param.value) headers[param.key] = param.value;
      });
    }

    let httpOpts: { headers: HttpHeaders; observe: any } = {
      headers: new HttpHeaders(headers),
      observe: 'response',
    };

    requestURL = encodeURI(requestURL);

    try {
      if (this._mobileService.isHybrid() && this._mobileService.doEnableSecureHTTP) {
        return this.sendSecureHTTPRequest(requestURL, request.method, request.body, headers);
      } else{
        switch (request.method) {
          case 'POST':
            return this.httpClient.post(requestURL, request.body, httpOpts).pipe(map(
              res => { this._commonService.hideSpinner(); return res; }
            ));
          case 'GET':
            return this.httpClient.get(requestURL, httpOpts);
          case 'PUT':
            return this.httpClient.put(requestURL, request.body, httpOpts).pipe(map(
              res => { this._commonService.hideSpinner(); return res; }
            ));
          case 'DELETE':
            return this.httpClient.delete(requestURL, httpOpts).pipe(map(
              res => { this._commonService.hideSpinner(); return res; }
            ));
          default:
            return throwError('METHOD NOT DEFINED');
        }
      }
    } catch (error) {
      return throwError(error).pipe(map(
        res => { this._commonService.hideSpinner(); return res; }
      ));
    }
  }

  invokeDownloadApi(request: HttpRequestPayload): Observable<any> {
    let requestURL = environment.baseURL;
    requestURL += request.serverContext
      ? request.serverContext
      : this.getDefaultContext();

    requestURL += request.resource;

    /** append the query params */
    if (request.queryParams) {
      requestURL += '?';
      for (let key in request.queryParams) {
        let item = request.queryParams[key];
        if (item.value) {
          requestURL += `${item.key}=${item.value}&`;
        }
      }
      requestURL = requestURL.substring(0, requestURL.length - 1);
    }

    let headers: any = {
      'authorization': this.authToken,
      'deviceInfo': this._commonService.encodedDeviceDetails,
      'languageId':environment.languageId
    };

    /** append the header params  */
    if (request.headerParams) {
      request.headerParams.map((param: any) => {
        headers[param.key] = param.value;
      });
    }

    let httpOpts: { headers: HttpHeaders; observe: any; responseType: any } = {
      headers: new HttpHeaders(headers),
      observe: 'response',
      responseType: "blob",
    };

    requestURL = encodeURI(requestURL);

    try {
      if (this._mobileService.isHybrid() && this._mobileService.doEnableSecureHTTP) {
        return this.secureFileDownload(requestURL, "GET", request.body, headers, "AccountStatement.pdf");
      }else {
        switch (request.method) {
          case 'POST':
            return this.httpClient.post(requestURL, request.body, httpOpts).pipe(map(
              res => { this._commonService.hideSpinner(); return res; }
            ));
          case 'GET':
            return this.httpClient.get<Blob>(requestURL, httpOpts);
          case 'PUT':
            return this.httpClient.put(requestURL, request.body, httpOpts).pipe(map(
              res => { this._commonService.hideSpinner(); return res; }
            ));
          case 'DELETE':
            return this.httpClient.delete(requestURL, httpOpts).pipe(map(
              res => { this._commonService.hideSpinner(); return res; }
            ));
          default:
            return throwError('METHOD NOT DEFINED');
        }
      }
    } catch (error) {
      return throwError(error);
    }

  }

  get authToken(): string {
    // return 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.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.I9vkqkWV4tVqgNYtht0YC2SwoJeoKokn-tj4ouJEnTk';
    return sessionStorage.getItem('access_token') && sessionStorage.getItem('access_token') != 'undefined' ? 'Bearer ' + sessionStorage.getItem('access_token') : "";
  }

  sendSecureHTTPRequest(
    url: string,
    method: "GET" | "POST" | "PUT" | "DELETE" | "PATCH",
    params: any = {},
    headers
  ): Observable<any> {
    this._secureHttp.setDataSerializer("json");
    let secureHTTPResponse;
    if (method == "GET") {
      secureHTTPResponse = this._secureHttp.get(url, params, headers);
    } else if (method == "POST") {
      secureHTTPResponse = this._secureHttp.post(url, params, headers);
    } else if (method == "PUT") {
      secureHTTPResponse = this._secureHttp.put(url, params, headers);
    } else if (method == "DELETE") {
      secureHTTPResponse = this._secureHttp.delete(url, params, headers);
    } else if (method == "PATCH") {
      secureHTTPResponse = this._secureHttp.patch(url, params, headers);
    }

    return from(secureHTTPResponse).pipe(
      map((response) => {
        this._commonService.hideSpinner();
        let newRes = {};
        newRes["body"] = response["data"] ? JSON.parse(response["data"]) : "";
        newRes["status"] = response["status"];
        //TODO: to check 401
        return newRes;
      })
    );
  }

  secureFileDownload(
    url: string,
    method: "GET" | "POST" | "PUT" | "DELETE",
    params: any = {},
    headers,
    fileName: string
  ): Observable<any> {
    var filePath = "";
    fileName = fileName || "document.pdf";

    switch (this._commonService.deviceInfo.os) {
      case "Android":
        filePath = cordova.file.externalDataDirectory + fileName;
        break;
      case "iOS":
        filePath = cordova.file.documentsDirectory + fileName;
        break;
    }

    return from(this._secureHttp.downloadFile(url, params, headers, filePath));
  }

  getDefaultContext(){
    return environment.defaultPublisher;
  }

}
